'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */
import { RichText } from '@hyphengroup/cms-components/components/RichText';
import classNames from 'classnames';
import { useState } from 'react';
import { BrandIcon } from '../../BrandIcon';
import Button from '../../Button';
import { ComponentExpandableCard } from '$/(cms)/_modules/cmsService/types';
import { pushDataLayer } from '$/components/cms/pushDataLayer';
import ExpandLess from '$/components/icons/ExpandLess';
import Tick from '$/components/icons/Tick';

export type ExpandableCardProps = ComponentExpandableCard & {
  headerType?: boolean;
};

export const ExpandableCard: React.FC<ExpandableCardProps> = ({
  id,
  title,
  expanded_by_default,
  content,
  fancy_list,
  show_logo,
}) => {
  const [expanded, setExpanded] = useState(expanded_by_default);

  const onClickExpanded = () => {
    pushDataLayer({
      event: 'navigate',
      component_type: 'accordion',
      component_title: `Header Section_${title}`,
      action: expanded ? 'collapse' : 'expand',
      index: '',
    });
    setExpanded(!expanded);
  };

  return (
    <div id={id}>
      <div className="max-w-4xl rounded-radius/button border border-borders/default bg-white">
        <div
          className={`flex max-h-max items-center justify-between p-spacing/padding/soft-8px ${!expanded ? '!mb-0' : 'border-b border-b-borders/default'}`}
          role="button"
          tabIndex={0}
          onClick={() => onClickExpanded()}
        >
          <div className="flex items-center space-x-2">
            {show_logo && <BrandIcon />}
            <div className="mhg-alpha-bullet-1 text-wrap">{title}</div>
          </div>
          <div>
            <Button
              variant="text"
              color="text-primary"
              className="max-h-max !px-0"
              aria-label={expanded ? 'Collapse' : 'Expand'}
              endIcon={
                <ExpandLess
                  className={classNames(
                    'size-5 transition-transform text-gray-900 md:size-6',
                    expanded ? 'rotate-0' : 'rotate-180',
                  )}
                />
              }
            />
          </div>
        </div>
        <div
          className={`p-spacing/padding/soft-8px alpha-body-2 sm:py-spacing/padding/soft-12px ${expanded ? 'block' : 'hidden'}`}
        >
          <span
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: content ?? '' }}
            className="mhg-alpha-body-1 text-gray-800"
          ></span>
          {fancy_list && (
            <ul className="mhg-alpha-body-1 flex flex-col gap-spacing/gap/soft-8px text-gray-900">
              {fancy_list.map((item) => (
                <li key={item?.id} className="flex items-center">
                  <i className="mr-2">
                    <Tick />
                  </i>
                  <RichText component="span">{item?.item ?? ''}</RichText>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};
